<template>
    <div class="page" id="page_gallery">
        <header class="mobile-hide">
            <h2>Gallery</h2>
        </header>
        
        <ul id="galleryLinks">
            <li v-for="image in images" :key="image.id" >
                <a @click="thumbsClick" :href="image.src"  :data-thumb-id="image.id">
                    <img :src="image.thumb" alt="" >
                    <!-- {{image.id}} -->
                </a>
            </li>
        </ul>
        <Viewer 
            v-if="viewerDisplay" 
            :currentImage="currentImage" 
            @viewerLeft="viewerLeft"
            @viewerRight="viewerRight"
            @viewerClose="viewerClose"
        >
        </Viewer>
    </div>
</template>

<script>
import Viewer from './Viewer';
export default {
    name: 'Gallery',
    //prop: [ 'thumbsClick' ],
    components: {
        Viewer
    },
    methods: {
        thumbsClick(e) {
            
            //window.console.log('thumb click', e.currentTarget.dataset.thumbId);
			const target = e.currentTarget.dataset.thumbId;
            this.currentImage = this.images[target];
            this.viewerDisplay = !this.viewerDisplay;

            e.preventDefault();
        },
        viewerLeft() {
            let index = this.currentImage.id;
            index--;
            if (index < 0)
                index = this.images.length -1;

            this.currentImage = this.images[index];
                
        },
        viewerRight() {
            let index = this.currentImage.id;
            index++;
            if (index >= this.images.length )
                index = 0;

            this.currentImage = this.images[index];
                
        },
        viewerClose() {
            this.viewerDisplay = false;
        }
    },
    data() {
         return {
            currentImage: null,
            viewerDisplay: false,
            images: [
                {
                    id: 0,
                    src: 'images/gallery/gallery01.jpg',
                    thumb: 'images/gallery/gallery-thumb01.jpg',
                    alt: ''
                },
                {
                    id: 1,
                    src: 'images/gallery/gallery02.jpg',
                    thumb: 'images/gallery/gallery-thumb02.jpg',
                    alt: ''
                },
                {
                    id: 2,
                    src: 'images/gallery/gallery03.jpg',
                    thumb: 'images/gallery/gallery-thumb03.jpg',
                    alt: ''
                },
                {
                    id: 3,
                    src: 'images/gallery/gallery04.jpg',
                    thumb: 'images/gallery/gallery-thumb04.jpg',
                    alt: ''
                },
                {
                    id: 4,
                    src: 'images/gallery/gallery05.jpg',
                    thumb: 'images/gallery/gallery-thumb05.jpg',
                    alt: ''
                },
                {
                    id: 5,
                    src: 'images/gallery/gallery06.jpg',
                    thumb: 'images/gallery/gallery-thumb06.jpg',
                    alt: ''
                },
                {
                    id: 6,
                    src: 'images/gallery/gallery07.jpg',
                    thumb: 'images/gallery/gallery-thumb07.jpg',
                    alt: ''
                },
                {
                    id: 7,
                    src: 'images/gallery/gallery08.jpg',
                    thumb: 'images/gallery/gallery-thumb08.jpg',
                    alt: ''
                },
                {
                    id: 8,
                    src: 'images/gallery/gallery09.jpg',
                    thumb: 'images/gallery/gallery-thumb09.jpg',
                    alt: ''
                },
                {
                    id: 9,
                    src: 'images/gallery/gallery10.jpg',
                    thumb: 'images/gallery/gallery-thumb10.jpg',
                    alt: ''
                },
                {
                    id: 10,
                    src: 'images/gallery/gallery11.jpg',
                    thumb: 'images/gallery/gallery-thumb11.jpg',
                    alt: ''
                },
                {
                    id: 11,
                    src: 'images/gallery/gallery12.jpg',
                    thumb: 'images/gallery/gallery-thumb12.jpg',
                    alt: ''
                },
                {
                    id: 12,
                    src: 'images/gallery/gallery13.jpg',
                    thumb: 'images/gallery/gallery-thumb13.jpg',
                    alt: ''
                },
                {
                    id: 13,
                    src: 'images/gallery/gallery14.jpg',
                    thumb: 'images/gallery/gallery-thumb14.jpg',
                    alt: ''
                },
                {
                    id: 14,
                    src: 'images/gallery/gallery15.jpg',
                    thumb: 'images/gallery/gallery-thumb15.jpg',
                    alt: ''
                }
            ]
        }
    }
}
</script>

<style lang="less" scoped>
#page_gallery {
    ul {
        display: flex;
        flex-wrap: wrap;
        margin:0;

        li {
            list-style: none;
            margin: 0; 
            padding: 0;
            width: 50%;

            &:hover img {
                opacity: 0.5;
            }
        }

        a {
            display: block;
        }
        img {
            width: 100%;
        }
    }
}

@media only screen and (min-width : 768px) {
    #page_gallery {
        ul li {
            width: 33.3%;
        }
    }
}
@media only screen and (min-width : 1024px) {
    #page_gallery {
        ul li {
            width: 25%;
        }
    }
}
</style>